import { getQueryParamsForScrollAndFocus } from '@/components/ux/hooks/use-scroll-and-focus';
import type { Reply } from '@/models/registry';
import type { Trade } from '@/models/types';

export const useGetTradeReplyUrl = (
  tradeShortId: Trade['short_id'],
  reply: Reply,
) => {
  // For trade replies, we'll create a URL that navigates to the trade appraisal
  // with query params to scroll to the specific reply
  const queryParams = getQueryParamsForScrollAndFocus({
    uiType: 'reply',
    id: reply.id,
  });

  // Construct the URL to the trade appraisal page
  const pathname = `/trade/${tradeShortId}/`;
  const searchParams = new URLSearchParams(queryParams);
  const url = `${pathname}?${searchParams.toString()}`;

  return `${window.location.origin}${url}`;
};
